import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Async, AsyncCreatable, Autocomplete, Creatable } from '@lightspeed/flame/Autocomplete';
import { themeGet } from '@lightspeed/flame/Core';

const defaultStyles = (props) => css`
  min-width: 180px;

  @media print {
    .cr-autocomplete__control {
      border: none;
      box-shadow: none;
      min-height: auto;
    }

    .cr-autocomplete__single-value {
      color: #000;
    }

    .cr-autocomplete__indicators {
      display: none;
    }
  }

  .cr-autocomplete__input {
    input {
      height: inherit !important;
      min-height: auto;
      box-shadow: none;
    }
  }

  .cr-autocomplete__value-container {
    overflow: visible;
  }

  &.listing {
    .cr-autocomplete__value-container--is-multi {
      padding: 2px 4px;
    }
  }

  .cr-autocomplete__option--is-selected {
    background-color: #ebf5ff;
  }

  &.gui-def-autocomplete {
    .cr-autocomplete__control {
      min-height: inherit;
      border-radius: 0;
      box-shadow: none;
      border: none;

      &:hover {
        border-color: #ddd;
      }
    }

    .cr-autocomplete__control--is-focused {
      box-shadow: inset 0 0 2px 2px #8fbbe5;
    }

    .cr-autocomplete__value-container {
      &:not(.cr-autocomplete__value-container--is-multi) {
        height: 32px;
      }

      .cr-autocomplete__placeholder,
      .cr-autocomplete__single-value {
        line-height: 32px;
      }
    }

    &.cr-autocomplete--is-disabled {
      border-left: none !important;

      .cr-autocomplete__control--is-disabled {
        background-color: transparent;
      }

      .cr-autocomplete__value-container {
        padding-left: 0;
      }

      .cr-autocomplete__single-value--is-disabled {
        color: inherit;
        margin-left: 0;
      }

      .cr-autocomplete__indicators {
        display: none;
      }
    }

    &.outer-table {
      .cr-autocomplete__control {
        border: 1px solid #ddd;
      }
    }
  }

  &.listing {
    min-width: 150px;
    max-width: 240px;

    .cr-autocomplete__control {
      border-color: #aaa;
      min-height: 34px;
      border-radius: 0;
    }
  }

  .cr-autocomplete__option {
    cursor: pointer;
  }

  .cr-autocomplete__indicators {
    min-width: 21px;
    > div {
      padding: 8px 4px !important;
    }
  }

  .cr-autocomplete__multi-value__remove {
    padding: 0 2px;
    color: ${themeGet('colors.gray-200')(props)};
    &:hover {
      color: ${themeGet('colors.maple-500')(props)};
    }
  }

  &.is-not-clearable {
    .cr-autocomplete__multi-value__remove {
      display: none;
    }
    .cr-autocomplete__multi-value__label {
      padding-right: 6px;
    }
  }

  .cr-autocomplete__menu-list {
    max-height: 287px;
  }
`;

export const StyledAutocomplete = styled(Autocomplete)`
  ${defaultStyles}
`;
export const StyledCreatable = styled(Creatable)`
  ${defaultStyles}
`;
export const StyledAsync = styled(Async)`
  ${defaultStyles}
`;
export const StyledAsyncCreatable = styled(AsyncCreatable)`
  ${defaultStyles}
`;
